import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("user/all");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async getUser({ commit }, payload) {
      let returnData = {};
      await api
        .get("user/" + payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      return returnData;
    },
    async newUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("user", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadUsers");
      return returnData;
    },
    async saveUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/update`, payload)
        .then((response) => {
          if (response.data.Status == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async resetUserTempPassword({ dispatch }, payload) {
      api.post(`users/resetTempPassword`, payload);
    },
    async userEmailChangeRequest({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/emailChangeRequest`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
            };
          } else {
            returnData = {
              Result: "Failed",
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadCurrentUserData");
      return returnData;
    },
    async userEmailVerification({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/verifyUserEmail`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
            };
          } else {
            returnData = {
              Result: "Failed",
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadCurrentUserData");

      return returnData;
    },
    async resetPasswordChangeRequest({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`user/passwordChangeRequest`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
            };
          } else {
            returnData = {
              Result: "Failed",
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
    async updateQuestionnaire({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`user/updateQuestionnaire`, payload)
        .then((result) => {
          returnData = result.data;
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
    async getQuestionnaire({ dispatch }, payload) {
      let returnData = {};

      await api
        .get(`user/getQuestionnaire/` + payload)
        .then((result) => {
          returnData = result.data;
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
    async updateProfilePicture({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`user/updateProfilePicture`, payload)
        .then((result) => {
          if (result.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: result.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: "There was an Error, Please try again later",
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });

      dispatch("auth/loadCurrentUserData", null, { root: true });
      return returnData;
    },

    async setupAuth0Account({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`user/setupAuth0Account`, payload)
        .then((result) => {
          if (result.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: result.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: "There was an Error, Please try again later",
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });

      dispatch("loadAll");
      return returnData;
    },

  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  },
};
